export enum NavigationOption {
  ROUTERLINK = 'routerLink',
  HREF = 'href',
}

export interface Breadcrumbs {
  url?: string;
  text: string;
  navigationOption?: NavigationOption;
}
